module.exports = __webpack_public_path__ + "img/zright2.2f4e373c.png";